import useUser from '@/hooks/useUser';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';
import { useNarrativeValuationCompany } from '@/pages/Narrative/hooks/useNarrativeValuationCompany';

import NotFound from '@/pages/NotFound';
import { PublicNarrativeCreate } from '@/pages/Narrative/components/PublicNarrativeCreate';
import { NarrativeLayout } from './NarrativeLayout';
import { NARRATIVE_USER_POSITION } from '@/pages/Narrative/utils/schema';

export const PublicNarrativeCreatePage = () => {
  const { getItem } = useQueryStringParam();

  const { data: user, queryStatus: userStatus } = useUser();

  const companyId = getItem('company');
  const initialUserHoldsPosition =
    getItem('position') === NARRATIVE_USER_POSITION.HOLDS;
  const { data: companyResponse, status: companyStatus } =
    useNarrativeValuationCompany(
      {
        companyId: companyId!,
      },
      {
        enabled: Boolean(companyId && user.loggedIn),
      }
    );
  const company = companyResponse?.Company;

  if (!companyId) {
    console.warn('"company" query param was not provided.');
  }

  if (!user.loggedIn || !companyId) {
    return <NotFound />;
  }

  const getError = () => {
    return (
      userStatus === 'error' ||
      companyStatus === 'error' ||
      typeof company === 'undefined'
    );
  };

  return (
    <NarrativeLayout
      title="Create Narrative"
      isLoading={userStatus === 'pending' || companyStatus === 'pending'}
      error={getError()}
    >
      {company && (
        <PublicNarrativeCreate
          company={company}
          initialUserHoldsPosition={initialUserHoldsPosition}
        />
      )}
    </NarrativeLayout>
  );
};
